import { GetStaticProps } from 'next'

import { Layout } from '~/components/Layout'
import Community from '~/sections/Community/Community'
import AboutHero from '~/sections/AboutHero/AboutHero'
import AboutTeam from '~/sections/AboutTeam/AboutTeam'
import AboutInvestors from '~/sections/AboutInvestors/AboutInvestors'
import { PageProps } from '~/lib/types'
import { getOverallStargazers } from '~/lib/useStargazers'
import { PAGE_ROUTES } from '~/constants'
import PillCTA from '~/sections/PillCTA/PillCTA'
import { getLayoutProps } from '~/lib/layout'
import { GITHUB_ALL_PUBLIC_REPOS } from '~/data'

export const getStaticProps: GetStaticProps = () => ({
  props: {
    orgRepoStargazers: getOverallStargazers(GITHUB_ALL_PUBLIC_REPOS),
    layoutProps: getLayoutProps(),
  },
})

interface Props extends PageProps {
  orgRepoStargazers: number
}

const About: React.FC<Props> = ({ orgRepoStargazers, layoutProps }) => {
  return (
    <Layout {...layoutProps} title='About'>
      <AboutHero />
      <AboutTeam />
      <PillCTA
        heading='Join us!'
        description={`
          We’re hiring across the board.
        `}
        button={{
          'text': 'See open positions',
          'link': PAGE_ROUTES.JOBS,
          'data-track': 'cta:see-open-roles:from-about-page',
        }}
      />
      <AboutInvestors />
      <Community orgRepoStargazers={orgRepoStargazers} />
    </Layout>
  )
}

export default About
